module.exports = __webpack_public_path__ + "img/huk2.460c40be.png";